var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNavHome(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 28.8 28.8",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.286,26.018h-5.439c-.552,0-1-.447-1-1v-6.628h-2.894v6.628c0,.553-.448,1-1,1h-5.405c-.552,0-1-.447-1-1v-10.087h-2.121c-.552,0-1-.447-1-1v-2.659c0-.33.163-.64.436-.826L13.836,2.956c.341-.232.787-.232,1.128,0l10.973,7.489c.273.187.436.496.436.826v2.659c0,.553-.448,1-1,1h-2.087v10.087c0,.553-.448,1-1,1h0ZM17.847,24.018h3.439v-10.087c0-.553.448-1,1-1h2.087v-1.131l-9.973-6.807-9.973,6.807v1.131h2.121c.552,0,1,.447,1,1v10.087h3.405v-6.628c0-.553.448-1,1-1h4.894c.552,0,1,.447,1,1v6.628Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNavHome);
export default __webpack_public_path__ + "static/media/Nav-Home.c5af9d896c6e133f915ad969bc6bc4f4.svg";
export { ForwardRef as ReactComponent };